import _ from 'lodash';
import * as api from './api';
import * as yup from 'yup';
import * as helpers from 'services/helpers';

export const BuySchema = yup.object().shape({
  name_of_farm: yup.string().required(),
  size_of_farm: yup.string().required(),
  location_id: yup.number().positive().required(),
  village_id: yup.number().positive().required(),
  taluka_id: yup.number().positive().required(),
  // city_id: yup.number().positive().required(),
  district_id: yup.number().positive().required(),
  state_id: yup.number().positive().required(),
  country_id: yup.number().positive().required(),
  pin_code: yup.string().required(),
  // address_line1: yup.string('Address Line 1 is required.').when('location_id', (location_id, schema) => {
  //   if (!location_id) {
  //     return schema.required();
  //   }

  //   return schema.optional();
  // }),
  crops: yup.array().of(
    yup.object().shape({
      farm_detail_id: yup.number().required(),
      crop_id: yup.number().positive().required(),
      crop_area: yup.number().positive().required(),
      harvest_date: yup.date().required(),
    }),
  ),
});

export const fetchTransportationCost = async (params = {}) => {
  try {
    let res = await api.fetchTransportationCost(params);
    return res;
  } catch (err) {
    throw err;
  }
};
